import 'bootstrap'
import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/engineering-calculator.css'

import './components/nav-bar/nav-bar-component.js'
import './components/footer-component.js'

//set up on shape click
for(let i = 0; i <= 10; i++) {
  document.getElementById(`shape-${i}`).onclick = () => onShapeSelected(i)
}

document.getElementById('set-english-units').onclick = setEnglishUnits
document.getElementById('set-metric-units').onclick = setMetricUnits

const ENGLISH_UNITS = "english";
const METRIC_UNITS = "metric";
let gUnits = ENGLISH_UNITS;

var cachedIndex = 1;

setUnits()

var cachedIndex = 1;

function onShapeSelected(index) {
  setupShape(index);
  const y = document.getElementById('beam-drawing-top').getBoundingClientRect().top + window.scrollY - 50
  window.scroll({ top: y, behavior: 'smooth'})
}

function setupShape(index) {
  shapes[index].SetupImages();
  shapes[index].SetupDimensionForm(index);
  //set the class to selected, clear others
  //$("#simple").children().removeClass("selected");
  //$("#common-structural").children().removeClass("selected");
  //$("#shape-" + index).addClass("selected");
  calculate(index);
}

function setEnglishUnits() {
  gUnits = ENGLISH_UNITS;
  setUnits();
  document.getElementById('units-dropdown').innerHTML = "English (in)"
}

function setMetricUnits() {
  gUnits = METRIC_UNITS;
  setUnits();
  document.getElementById('units-dropdown').innerHTML = "English (mm)"
}

function setUnits() {
  if (gUnits == ENGLISH_UNITS) {
    changeUnits('units-length', 'in');
  } else {
    changeUnits('units-length', 'mm');
  }
}

function changeUnits(cssClassName, newUnitStr) {
  var elements = document.getElementsByClassName(cssClassName);
  for (var i = 0; i < elements.length; i++) {
    elements.item(i).innerHTML = newUnitStr;
  }
}

function calculate(index) {
  setUnits();
  shapes[index].Calculate();
  cachedIndex = index;
}

function recalculate() {
  calculate(cachedIndex);
}


var shapes = [];

function ShapeClass() {
  this.imagePath = "";
  this.eqnImagePath = "";
  this.area = "";
  this.xc = "";
  this.yc = "";
  this.ix = "";
  this.iy = "";
  this.ixy = "";
  this.ip = "";
  this.dimensions = [];
}

ShapeClass.prototype.AddDimension = function (dimName, defaultValue, unit) {
  this.dimensions.push({ name: dimName, value: defaultValue, unit: unit });
};

ShapeClass.prototype.showEqn = function (shapeProperty, divID) {
  if (this[shapeProperty] !== "" || this[shapeProperty] === undefined) {
    var str = "`" + shapeProperty + "=" + this[shapeProperty] + "`<span style='display:inline' id='" + shapeProperty + "ans2'></span>";
    var div = document.getElementById(divID);
    div.innerHTML = str;
    MathJax.Hub.Queue(["Typeset", MathJax.Hub, divID]);
  }
};


ShapeClass.prototype.SetupImages = function (index) {
  var str = '<img src="' + this.imagePath + '"/>';
  document.getElementById("current-shape-image").innerHTML = str;
  this.showEqn("A", "current-shape-area-eqns");
  this.showEqn("xc", "current-shape-xc-eqns");
  this.showEqn("yc", "current-shape-yc-eqns");
  this.showEqn("Ix", "current-shape-ix-eqns");
  this.showEqn("Iy", "current-shape-iy-eqns");
  this.showEqn("Ixy", "current-shape-ixy-eqns");
  this.showEqn("Ip", "current-shape-ip-eqns");
};

ShapeClass.prototype.SetupDimensionForm = function (index) {
  //put the user dimensions on the worksheet
  let text = "<form name='shape_data'>";
  for (var i = 0; i < this.dimensions.length; i++) {
    if (this.dimensions[i] !== undefined) {
      var label = this.dimensions[i].name;
      var value = this.dimensions[i].value;
      var unit = this.dimensions[i].unit;
      text += '<div class="form-group">';
      text += '<label class="control-label" for="' + label + '"><i>' + label + ' (<span class="' + unit + '"></span>)</i></label>';
      text += '<input class="form-control" type="text" id="' + label + '" value="' + value + '" onchange="recalculate();"></div>';
    }
  }

  document.getElementById('dimensions').innerHTML = text
  document.getElementById('calculate-button').innerHTML = '<p class="btn btn-primary btn-lg shadow" role="button">Calculate</p>'

  for (i = 0; i < this.dimensions.length; i += 1) {
    document.getElementById(`${this.dimensions[i].name}`).onchange = recalculate
  }

  document.getElementById('calculate-button').onclick = () => calculate(index)
};

function evalExpressionAtX(expression) {
  // these must be "defined" here in order to eval them
  var c = 0, pi = Math.PI, b = 0, b_f = 0, b_w = 0, h = 0, t = 0, t_f = 0, t_w = 0, h = 0, h_w = 0, h_f = 0, r = 0
  var str = expression;
  var ind = str.lastIndexOf("\n");
  if (ind == str.length - 1) {
    str = str.slice(0, ind);
  }
  str = str.slice(str.lastIndexOf("\n") + 1);
  var res = 0;
  try {
    res = eval(str); // jshint ignore:line
  } catch (e) {
    console.log(e)
  }
  return parseFloat(res);
}

/*
 * We're using straight up js eval for our calcs. so we must replace our pretty ^ (power)
 * with Math.pow(...). not the most elegant regex but it works for our equations :)
 */
function convertToMathDotPow(func) {
  var newFunc = func.replace(/(b|b_f|b_w|h|t|t_f|t_w|h|h_w|h_f|r)\^(\d)/g, "Math.pow($1,$2)");
  return newFunc;
}

ShapeClass.prototype.EvalFunction = function (func) {
  func = convertToMathDotPow(func);
  var text = "";
  for (var i = 0; i < this.dimensions.length; i++) {
    //get the data from our form
    this.dimensions[i].value = document.shape_data[this.dimensions[i].name].value;
    text += this.dimensions[i].name + "=" + this.dimensions[i].value + ";";
  }

  if(func === '-') {
    text += '0;'
  } else {
    text += "pi = " + Math.PI + ";"
    text += func + ";"
  }
  return evalExpressionAtX(text);
};

ShapeClass.prototype.Calculate = function () {
  var area = this.EvalFunction(this.A);
  var unitsSpan = " <span class='units-length'></span>";
  document.getElementById("Aans").innerHTML = area.toFixed(5) + unitsSpan + "<sup>2</sup>";

  var xcentroid = this.EvalFunction(this.xc);
  document.getElementById("xcans").innerHTML = xcentroid.toFixed(5) + unitsSpan;

  var ycentroid = this.EvalFunction(this.yc);
  document.getElementById("ycans").innerHTML = ycentroid.toFixed(5) + unitsSpan;

  var Ixeval = this.EvalFunction(this.Ix);
  document.getElementById("Ixans").innerHTML = Ixeval.toFixed(5) + unitsSpan + "<sup>4</sup>";

  var Iyeval = this.EvalFunction(this.Iy);
  document.getElementById("Iyans").innerHTML = Iyeval.toFixed(5) + unitsSpan + "<sup>4</sup>";

  var Ixyeval = this.EvalFunction(this.Ixy);
  document.getElementById("Ixyans").innerHTML = Ixyeval.toFixed(5) + unitsSpan + "<sup>4</sup>";

  var Ipeval = this.EvalFunction(this.Ip);
  document.getElementById("Ipans").innerHTML = Ipeval.toFixed(5) + unitsSpan + "<sup>4</sup>";
};

//rectangle
var rectangle = new ShapeClass();
rectangle.imagePath = "cross-section-calculator/images/rectangle.png";
rectangle.areaImagePath = "cross-section-calculator/images/equations/square/area.png";
rectangle.A = "b*h";
rectangle.xc = "b/2";
rectangle.yc = "h/2";
rectangle.Ix = "(b*h^3)/12";
rectangle.Iy = "(h*b^3)/12";
rectangle.Ixy = "0";
rectangle.Ip = "(b*h)/12*(h^2+b^2)";
rectangle.AddDimension("h", "50", "units-length");
rectangle.AddDimension("b", "10", "units-length");
shapes.push(rectangle);

//triangle
var triangle = new ShapeClass();
triangle.imagePath = "cross-section-calculator/images/triangle.png";
triangle.A = "(b*h)/2";
triangle.xc = "(b+c)/3";
triangle.yc = "h/3";
triangle.Ix = "(b*h^3)/36";
triangle.Iy = "(b*h)/36*(b^2-b*c+c^2)";
triangle.Ixy = "(b*h^2)/72*(b-2*c)";
triangle.Ip = "(b*h)/36*(h^2+b^2-b*c+c^2)";
triangle.AddDimension("h", "50", "units-length");
triangle.AddDimension("b", "70", "units-length");
triangle.AddDimension("c", "10", "units-length");
shapes.push(triangle);

//isosceles
var isosceles = new ShapeClass();
isosceles.imagePath = "cross-section-calculator/images/isosceles.png";
isosceles.A = "(b*h)/2";
isosceles.xc = "b/2";
isosceles.yc = "h/3";
isosceles.Ix = "(b*h^3)/36";
isosceles.Iy = "(b^3*h)/48";
isosceles.Ixy = "0";
isosceles.Ip = "(b*h)/144*(4*h^2+3*b^2)";
isosceles.AddDimension("h", "50", "units-length");
isosceles.AddDimension("b", "10", "units-length");
shapes.push(isosceles);

//right triangle
var rightTriangle = new ShapeClass();
rightTriangle.imagePath = "cross-section-calculator/images/right.png";
rightTriangle.A = "(b*h)/2";
rightTriangle.xc = "b/3";
rightTriangle.yc = "h/3";
rightTriangle.Ix = "(b*h^3)/36";
rightTriangle.Iy = "(b^3*h)/36";
rightTriangle.Ixy = "-(b^2*h^2)/72";
rightTriangle.Ip = "(b*h)/36*(h^2+b^2)";
rightTriangle.AddDimension("h", "50", "units-length");
rightTriangle.AddDimension("b", "10", "units-length");
shapes.push(rightTriangle);

//rod
var rod = new ShapeClass();
rod.imagePath = "cross-section-calculator/images/rod.png";
rod.A = "pi*r^2";
rod.xc = "0";
rod.yc = "0";
rod.Ix = "(pi*r^4)/4";
rod.Iy = "(pi*r^4)/4";
rod.Ixy = "0";
rod.Ip = "(pi*r^4)/2";
rod.AddDimension("r", "50", "units-length");
shapes.push(rod);

//pipe
var pipe = new ShapeClass();
pipe.imagePath = "cross-section-calculator/images/pipe.png";
pipe.A = "2*pi*r*t";
pipe.xc = "0";
pipe.yc = "0";
pipe.Ix = "pi*r^3*t";
pipe.Iy = "pi*r^3*t";
pipe.Ixy = "0";
pipe.Ip = "2*pi*r^3*t";
pipe.AddDimension("r", "50", "units-length");
pipe.AddDimension("t", "1", "units-length");
shapes.push(pipe);

//half circle
var halfCircle = new ShapeClass();
halfCircle.imagePath = "cross-section-calculator/images/half_circle.png";
halfCircle.A = "pi*r^2/2";
halfCircle.xc = "0";
halfCircle.yc = "4*r/(3*pi)";
halfCircle.Ix = "(9*pi^2-64)*r^4/(72*pi)";
halfCircle.Iy = "pi*r^4/8";
halfCircle.Ixy = "0";
halfCircle.Ip = "0";
halfCircle.AddDimension("r", "50", "units-length");
shapes.push(halfCircle);

//i shape
var IShape = new ShapeClass();
IShape.imagePath = "cross-section-calculator/images/I_shape.png";
IShape.A = "h_w*t_w+2*b_f*t_f";
IShape.xc = "b_f/2";
IShape.yc = "(h_w+2*t_f)/2";
IShape.Ix = "(h_w^3*t_w+8*b_f*t_f^3+12*b_f*h_w*t_f^2+6*b_f*h_w^2*t_f)/12";
IShape.Iy = "(h_w*t_w^3+2*b_f^3*t_f)/12";
IShape.Ixy = "-";
IShape.Ip = "-";
IShape.AddDimension("b_f", "10", "units-length");
IShape.AddDimension("h_w", "10", "units-length");
IShape.AddDimension("t_w", "1", "units-length");
IShape.AddDimension("t_f", "1", "units-length");
shapes.push(IShape);

var TShape = new ShapeClass();
TShape.imagePath = "cross-section-calculator/images/T_shape.png";
TShape.A = "b_f*t_f+h_w*t_w";
TShape.xc = "b_f/2";
TShape.yc = "(h_w^2*t_w+b_f*t_f^2+2*b_f*h_w*t_f)/(2*h_w*t_w+2*b_f*t_f)";
TShape.Ix = "(h_w^4*t_w^2+t_w*(4*b_f*h_w*t_f^3+6*b_f*h_w^2*t_f^2+4*b_f*h_w^3*t_f)+b_f^2*t_f^4)/(12*h_w*t_w+12*b_f*t_f)";
TShape.Iy = "(h_w*t_w^3)/12+(b_f^3*t_f)/12";
TShape.Ixy = "-";
TShape.Ip = "-";
TShape.AddDimension("b_f", "10", "units-length");
TShape.AddDimension("h_w", "10", "units-length");
TShape.AddDimension("t_w", "1", "units-length");
TShape.AddDimension("t_f", "1", "units-length");
shapes.push(TShape);

var LShape = new ShapeClass();
LShape.imagePath = "cross-section-calculator/images/L_shape.png";
LShape.A = "t*(h-t)+b*t";
LShape.xc = "-(t*(t^2-h*t-b^2))/(2*(t*(h-t)+b*t))";
LShape.yc = "-(t^2*(h-b)-h^2*t)/(2*(t*(h-t))+b*t)";
LShape.Ix = "-(t*(4*t^4-10*h*t^3-14*b*t^3+9*h^2*t^2+28*b*h*t^2+b^2*t^2-4*h^3*t-18*b*h^2*t+h^4+4*b*h^3))/(12*(t-h-b))";
LShape.Iy = "-(t*(t^4-2*h*t^3-4*b*t^3+h^2*t^2+4*b*h*t^2+6*b^2*t^2-6*b^2*h*t-4*b^3*t+4*b^3*h+b^4))/(12*(t-h-b))";
LShape.Ixy = "-";
LShape.Ip = "-";
LShape.AddDimension("b", "10", "units-length");
LShape.AddDimension("h", "10", "units-length");
LShape.AddDimension("t", "1", "units-length");
shapes.push(LShape);

var CShape = new ShapeClass();
CShape.imagePath = "cross-section-calculator/images/C_shape.png";
CShape.A = "h_w*t_w+2*b_f*t_f";
CShape.xc = "(h_w*t_w^2+2*b_f^2*t_f)/(2*(h_w*t_w+2*b_f*t_f))";
CShape.yc = "t_f+h_w/2";
CShape.Ix = "(h_w^3*t_w+8*b_f*t_f^3+12*b_f*h_w*t_f^2+6*b_f*h_w^2*t_f)/12";
CShape.Iy = "(h_w^2*t_w^4+8*b_f*h_w*t_f*t_w^3-12*b_f^2*h_w*t_f*t_w^2+8*b_f^3*h_w*t_f*t_w+4*b_f^4*t_f^2)/(12*(h_w*t_w+2*b_f*t_f))";
CShape.Ixy = "-";
CShape.Ip = "-";
CShape.AddDimension("t_f", "5", "units-length");
CShape.AddDimension("h_w", "20", "units-length");
CShape.AddDimension("b_f", "20", "units-length");
shapes.push(CShape);

shapes[1].SetupImages();
shapes[1].SetupDimensionForm(1);
calculate(1);
